module.exports = __webpack_public_path__ + "static/image2-8be08d543ddd2691feb88bc94112f374.png";